<template>
    <div class="not_found">
        <div class="container">
        <div class="card">
            <div class="card-header"><h1>We're sorry, <a href="#/not_found">Page</a> is nowhere to be found!</h1></div>
            <div class="card-body">
                <h2>
                    <a id="four-o-four-contact-link">Contact the Developer</a>
                </h2>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
    function mailto_from_data(data) {
        var to = data["to"];
        delete data["to"];
        var url = "mailto:"+to+"?";
        var fields = [];
        for(key in data) {
            fields.push([key,data[key]].join("="));
        }
        url = url + fields.join("&");
        return encodeURI(url);
    }
    var link_data = {
        to:"dmitchell.dm74@gmail.com",
        subject:"HIS_APP_404",
        body:`The content below is for the developer,\
        if you have any extra concerns please state them above this message.
        REQ_URL -> {{request.url}}
        UAGENT -> {{request.headers['User-Agent']}}
        `
    };
    export default {

    }
</script>